export function radToDeg(rad) {
    return rad * 180 / Math.PI;
}
export function metrePerSecondToKnot(metrePerSecond) {
    return metrePerSecond * 1.9438445;
}
export function metrePerSecondToFeetPerMinute(metrePerSecond) {
    return metrePerSecond * 196.8504;
}
export function metresToFeet(metres) {
    return metres * 3.28084;
}
export function convertThetaPhiToLatLng(theta, phi) {
    const lat = 90 - ((theta * 180) / Math.PI);
    const lng = phi * 180 / Math.PI;
    return { lat, lng };
}
